/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './ValidationDataRowLabel.scss';

import { arrayOf, bool, func, node, shape, string } from 'prop-types';
import React from 'react';

import { ReactComponent as WarningIcon } from 'assets/icons/warning-circle.svg';
import Store from 'state/Store';
import {
  fieldIsInvalid,
  fieldIsValid
} from 'state/validation/ValidationActions';
import { getUpdatedFieldName } from 'support/AddressUtils';

class ValidationDataRowLabel extends React.Component {
  state = {
    errorMessage: '',
    isValid: true
  };
  componentDidMount() {
    this.checkValidation();
  }

  componentDidUpdate(prevProps) {
    const { validators } = this.props;
    let validateAgain = false;

    for (let i = 0; i < validators.length; i++) {
      const prevValue = prevProps.validators[i].value;
      const currValue = validators[i].value;
      const prevShouldValidate = prevProps.validators[i].shouldValidate;
      const currShouldValidate = validators[i].shouldValidate;
      if (
        prevValue !== currValue ||
        prevShouldValidate !== currShouldValidate
      ) {
        validateAgain = true;
        break;
      }
    }
    if (validateAgain) {
      this.checkValidation();
    }
  }

  checkValidation() {
    const { validators, mailingType, hasResidential } = this.props;
    let isValid = true;
    let result;

    for (const validator of validators) {
      if (validator.shouldValidate) {
        result = validator.validator(validator.value);
        isValid = result === true;
        const fieldName = getUpdatedFieldName(validator.field, hasResidential, mailingType);
        if (!isValid) {
          Store.dispatch(fieldIsInvalid(fieldName, result));
          break;
        } else {
          Store.dispatch(fieldIsValid(fieldName));
        }
      }
    }

    this.setState({
      isValid,
      errorMessage: result
    });
  }

  render() {
    const { children } = this.props;
    const { errorMessage, isValid } = this.state;

    if (isValid) {
      return (
        <div className="validation-data-row-label-wrapper">
          <span className="validation-data-row-label">{children}</span>
        </div>
      );
    }
    return (
      <div className="validation-data-row-label-wrapper validation-data-row-label-invalid-wrapper">
        <WarningIcon className="invalid-icon" />
        <div className="validation-data-row-label-invalid">
          <span className="validation-data-row-label">{children}</span>
          <div className="validation-data-row-label-error-reason">
            {errorMessage}
          </div>
        </div>
      </div>
    );
  }
}

ValidationDataRowLabel.defaultProps = {
  validators: []
};

ValidationDataRowLabel.propTypes = {
  children: node.isRequired,
  validators: arrayOf(
    shape({
      field: string,
      shouldValidate: bool,
      validator: func,
      value: string
    })
  )
};

export default ValidationDataRowLabel;
